export interface CanvasFrameResult {
  iframeId: string;
  dataUri: string;
  escapedCode: string;
  fullHtml: string;
}

export function buildCanvasFrame(cleanCode: string): CanvasFrameResult {
  const escapedCode = cleanCode.replace(/&/g, "&amp;").replace(/"/g, "&quot;");

  const iframeId = `canvas-iframe-${Math.random()
    .toString(36)
    .substring(2, 9)}`;

  let fullHtml = cleanCode;

  const tailwindScript = `<script src="https://cdn.tailwindcss.com"></script>`;
  const fontAwesome = `<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">`;
  const baseStyles = `<style>body { margin: 0; padding: 16px; font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; box-sizing: border-box; background-color: #ffffff; color: #1e293b; } * { box-sizing: border-box; }</style>`;

  const headerInjections = `${tailwindScript}\n${fontAwesome}\n${baseStyles}`;

  if (!fullHtml.toLowerCase().includes("<head")) {
    if (!fullHtml.toLowerCase().includes("<html")) {
      fullHtml = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">${headerInjections}</head><body>${fullHtml}</body></html>`;
    } else {
      fullHtml = fullHtml.replace(
        /<html[^>]*>/i,
        match =>
          `${match}<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">${headerInjections}</head>`
      );
    }
  } else {
    fullHtml = fullHtml.replace(/<\/head>/i, `${headerInjections}</head>`);
  }

  const resizeScript = `<script>
    function sendHeight() {
      const height = Math.max(
        document.body ? document.body.scrollHeight : 0,
        document.documentElement ? document.documentElement.scrollHeight : 0
      );
      window.parent.postMessage({ type: 'resize-iframe', iframeId: '${iframeId}', height: height }, '*');
    }
    window.addEventListener('load', sendHeight);
    window.addEventListener('resize', sendHeight);
    if (window.MutationObserver && document.body) {
      new MutationObserver(sendHeight).observe(document.body, { childList: true, subtree: true, attributes: true });
    }
    setTimeout(sendHeight, 100);
    setTimeout(sendHeight, 400);
    setTimeout(sendHeight, 1000);

    document.addEventListener('click', function(event) {
      const link = event.target.closest('a');
      if (link) {
        event.preventDefault();
        const href = link.getAttribute('href') || '';
        const text = link.innerText || link.textContent || '';
        window.parent.postMessage({
          type: 'canvas-link-click',
          href: href,
          text: text.trim()
        }, '*');
      }
    });
  </script>`;

  if (fullHtml.includes("</body>")) {
    fullHtml = fullHtml.replace("</body>", resizeScript + "</body>");
  } else {
    fullHtml += resizeScript;
  }

  const base64Content = window.btoa(unescape(encodeURIComponent(fullHtml)));
  const dataUri = `data:text/html;charset=utf-8;base64,${base64Content}`;

  return {
    iframeId,
    dataUri,
    escapedCode,
    fullHtml
  };
}
